import { message } from "antd";

/** Барааны зурагт зөвшөөрөх өргөтгөлүүд */
export const PRODUCT_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png"];

/**
 * `<Upload accept>`-д өгөх утга.
 *
 * Өмнө нь `accept` огт тавигддаггүй байсан тул файл сонгох цонхонд docx, exe
 * зэрэг ямар ч төрлийн файл харагдаж, хэрэглэгч сонгосныхоо дараа л
 * татгалзуулдаг байв.
 */
export const PRODUCT_IMAGE_ACCEPT = PRODUCT_IMAGE_EXTENSIONS.map((ext) => `.${ext}`).join(",");

const isValidFileSize = (file) => file.size < 5000001;

const beforeUploadProductImg = (file) => {
  if (!isValidFileSize(file)) {
    message.error("Файлын хэмжээ 5mb -аас бага байх ёстой!", 5);
    return false;
  }
  const isImageFile = (file) => {
    const fileExtension = file.name.split(".").pop().toLowerCase();
    return PRODUCT_IMAGE_EXTENSIONS.includes(fileExtension);
  };
  if (!isImageFile(file)) {
    message.error("Зураг JPG/PNG/JPEG байх ёстой!", 5);
    return false;
  }

  return true;
};

export { beforeUploadProductImg };
